/** Deterministic error fingerprint: same error.name + message always produces
 *  the same ERR-XXXXXXX code so one bug = one DB row = one GitHub issue. */
export function errorFingerprint(name: string, message: string): string {
  const input = `${name}:${message}`;
  let h = 0;
  for (let i = 0; i < input.length; i++) {
    h = (Math.imul(31, h) + input.charCodeAt(i)) >>> 0;
  }
  return 'ERR-' + h.toString(36).toUpperCase().padStart(7, '0');
}
